import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';

import { Template } from '../../../../_models/template';
import { Size } from '../../../../_models/size';

@Component({
  selector: 'app-update-title',
  templateUrl: './update-title.component.html',
  styleUrls: ['./update-title.component.css']
})
export class UpdateTitleComponent implements OnInit {
  @Input() template: Template;
  @Input() size: Size;
  @Input() newCard: boolean;
  @Output() title = new EventEmitter<string>();
  @Output() disableForm = new EventEmitter<boolean>();
  titleForm: FormGroup;

  constructor(private formBuilder: FormBuilder) { }

  ngOnInit() {
    let forbiddenValues = [];
    for (let card of this.size.cards) {
      forbiddenValues.push(card.name)
    }
    if (!this.newCard) {
      forbiddenValues = forbiddenValues.filter(v => v != this.template.name)
    }
    this.titleForm = this.formBuilder.group({
      'title': [this.template.name, [Validators.required, (control: AbstractControl) => {
        return forbiddenValues.indexOf(control.value) === -1 ? null : {'forbiddenValue': true};
      }]]
    });

    this.titleForm.valueChanges.subscribe(data => {
      this.title.emit(data.title);
    });

    if (this.titleForm.status === 'INVALID') { this.disableForm.emit(true)}

    this.titleForm.statusChanges.subscribe((status) => {
      if (status === 'VALID') { this.disableForm.emit(false)}
      if (status === 'INVALID') { this.disableForm.emit(true)}
    })
  }

}



// WEBPACK FOOTER //
// /app/src/app/hq/cards/modify-card/update-title/update-title.component.ts